import * as map from "@/api/map.js";
// import * as menu from "@/api/menu.js";
import { setLayer, setExtraLayer } from "@/utils/map.js";
import setting from "@/assets/setting.json";
import { commonFunctions } from "@/utils/index";

function getId(id) {
  const cluster_id_map = {
    // 토지이용 계획
    "efe81ca4-62c1-434d-a6d8-5f850ccfd466":
      "8ca73eb1-a282-42a8-8fcb-7569239562a6",
    // "efe81ca4-62c1-434d-a6d8-5f850ccfd466": "8d4ddb96-795d-4622-b08e-1b16af2aa138",
    // 재개발
    "8085b649-a7ec-4139-8a46-2bec2c1988ca":
      "2cfb940b-cb10-4c4b-9036-6ecc30dce714",
    // 관광숙박시설
    "8fb6ecad-98bb-46e5-9283-b792e84d6457":
      "4298de69-163c-4b68-97ad-5e9510a42a86",
    // 아파트
    "82f6d811-7f7a-46fc-bd1b-35d3a3926f39":
      "c35239b7-22f3-4c64-a143-ccfa3014ce5f",
    // 오피스텔
    "3c9ffc69-74d7-4fe4-80ed-fd18dccb1f93":
      "756d6911-623a-4be0-b1c8-ce0820ac7a8a",
  };

  return cluster_id_map[id] || id;
}

export default {
  state: {
    // Map
    zoom: 10,
    center: [127.05321410704653, 37.48874619351901],
    rotation: 0,
    isCenterUpdate: false,
    scale: "",

    // Adress Search
    addressPin: [],

    // Map source
    mapList: setting.mapList,
    mapList_split: setting.mapList,
    mapType: {},
    mapTypeSplit: {},
    splitScreen: false,
    roadView: false,
    markerOn: false,
    markerPosition: [],

    // Map Interaction
    clickCoordinate: [],
    clickPixel: [],
    activeDrawingId: null,
    drawingStyle: null,
    drawType: null,
    isResetTools: false,
    uploadedImage: null,

    // Feature Properties
    feature: null,
    featureProperties: {},
    extraProperties: false,
    isRefreshLayer: null,
    isRefreshWithoutClearLayer: null,
    modifyFeatures: [],

    // Layers
    activeLayers: [],
    activeLayersIds: [],
    activeParentsIds: [],
    extraLayers: [],
    extraLayersIds: [],
    hideLayers: [],

    // User
    favoriteLayerIds: [],

    // 중복 불가능 항목
    itemDuplList: setting.itemDuplList,
    aptType: "", //아파트
    offType: "", //오피스텔

    // Active Category, TODO: move to menu.js
    activeTab: "전체",
    activeCategory: "공간",

    showCadastralMap: false,
    loading: false,

    hideLabel: {},

    // hide All Ovaraly
    isHideOverlay: false,

    // Dev
    dev: {
      font: 2,
      stroke: -3,
    },
  },
  getters: {
    // Map
    getZoom: (state) => state.zoom,
    getCenter: (state) => state.center,
    getRotation: (state) => state.rotation,
    getScale: (state) => state.scale,
    getMapType: (state) => state.mapType,
    getMapTypeSplit: (state) => state.mapTypeSplit,
    getMapList: (state) => state.mapList,
    getMapListSplit: (state) => state.mapList_split,
    getIsCenterUpdate: (state) => state.isCenterUpdate,

    // Feature
    getProperties: (state) => state.featureProperties,
    getFeature: (state) => state.feature,
    getIsRefreshLayer: (state) => state.isRefreshLayer,
    getIsRefreshWithoutClearLayer: (state) => state.isRefreshWithoutClearLayer,
    getModifyFeatures: (state) => state.modifyFeatures,

    // Utils
    getClickPixel: (state) => state.clickPixel,
    getClickCoordinate: (state) => state.clickCoordinate,
    getSplitScreen: (state) => state.splitScreen,
    getExtraProperties: (state) => state.extraProperties,
    getActiveDrawingId: (state) => state.activeDrawingId,
    getIsResetTools: (state) => state.isResetTools,
    getShowCadastralMap: (state) => state.showCadastralMap,
    getRoadView: (state) => state.roadView,
    getMarkerOn: (state) => state.markerOn,
    getMarkerPosition: (state) => state.markerPosition,

    // Catrgoty
    getActiveTab: (state) => state.activeTab,
    getActiveCategory: (state) => state.activeCategory,
    getActiveLayers: (state) => state.activeLayers,
    getActiveLayersIds: (state) => state.activeLayersIds,
    getActiveParentsIds: (state) => state.activeParentsIds,
    getExtraLayers: (state) => state.extraLayers,
    getExtraLayersIds: (state) => state.extraLayersIds,
    getFavoriteLayerIds: (state) => state.favoriteLayerIds,
    getAddressPin: (state) => state.addressPin,
    getDrawingStyle: (state) => state.drawingStyle,
    getDrawType: (state) => state.drawType,

    // ItemType
    getItemDuplList: (state) => state.itemDuplList,
    getAptType: (state) => state.aptType,
    getOffType: (state) => state.offType,

    getHideLayers: (state) => state.hideLayers,
    getLoading: (state) => state.loading,
    getUploadedImage: (state) => state.uploadedImage,
    getHideLabel: (state) => state.hideLabel,
    getIsHideOverlay: (state) => state.isHideOverlay,

    // Dev
    getDev: (state) => state.dev,
  },
  mutations: {
    SET_ZOOM(state, payload) {
      payload = Math.round(payload);
      state.zoom = payload;
    },
    SET_CENTER(state, payload) {
      state.center = [
        Number(payload[0].toFixed(6)),
        Number(payload[1].toFixed(6)),
      ];
    },
    SET_ROTATION(state, payload) {
      state.rotation = payload;
    },
    SET_SCALE(state, payload) {
      state.scale = payload;
    },
    SET_MAPTYPE(state, payload) {
      state.mapType = payload;
    },
    SET_MAPTYPE_SPLIT(state, payload) {
      state.mapTypeSplit = payload;
    },
    SET_IS_CENTER_UPDATE(state, payload) {
      state.isCenterUpdate = payload;
    },
    SET_CLICK_PIXEL(state, payload) {
      state.clickPixel = payload;
    },
    SET_CLICK_COORDINATE(state, payload) {
      state.clickCoordinate = payload;
    },
    SET_SPLIT_SCREEN(state, payload) {
      state.splitScreen = payload;
    },
    SET_FEATURE(state, payload) {
      state.feature = payload;
    },
    SET_ALL_FEATURE_PROPERTIES(state, payload) {
      state.featureProperties = payload;
    },
    SET_FEATURE_PROPERTIES(state, payload) {
      this._vm.$set(state.featureProperties, payload.id, payload.data);
      //state.featureProperties[payload.id] = payload.data;
    },
    SET_EXTRA_PROPERTY(state, payload) {
      state.extraProperties = payload;
    },
    SET_MODIFY_FEATURES(state, payload) {
      state.modifyFeatures = payload;
    },
    SET_IS_REFRESG_LAYER(state, payload) {
      state.isRefreshLayer = payload;
    },
    SET_IS_REFRESG_WITHOUT_CLEAR_LAYER(state, payload) {
      state.isRefreshWithoutClearLayer = payload;
    },
    SET_IS_RESET_TOOLS(state, payload) {
      state.isResetTools = payload;
    },
    SET_ACTIVE_TAB(state, payload) {
      state.activeTab = payload;
    },
    SET_ACTIVE_CATEGORY(state, payload) {
      state.activeCategory = payload;
    },
    CLEAR_ACTIVE_LAYERS(state) {
      state.activeLayers = [];
      state.activeLayersIds = [];
    },
    SET_LAYERS(state, payload) {
      state.activeLayers = payload;
      let ids = [];
      payload.forEach((layer) => {
        ids.push(layer.id);
      });
      state.activeLayersIds = ids;
    },
    SET_ACTIVE_LAYERS(state, payload) {
      if (!state.activeLayersIds.includes(payload.id)) {
        state.activeLayers.push(payload);
        state.activeLayersIds.push(payload.id);
      }
    },
    DEL_ACTIVE_LAYERS(state, payload) {
      if (state.activeLayersIds.includes(payload.id)) {
        commonFunctions.popById(state.activeLayers, payload.id);
        commonFunctions.popByData(state.activeLayersIds, payload.id);
      }
    },
    SET_ACTIVE_PARENTS_IDS(state, payload) {
      state.activeParentsIds.push(payload);
    },
    DEL_ACTIVE_PARENTS_IDS(state, payload) {
      commonFunctions.popByData(state.activeParentsIds, payload);
    },
    SET_ACTIVE_DRAWING_ID(state, payload) {
      state.activeDrawingId = payload;
    },
    SET_EXTRA_LAYERS(state, payload) {
      state.extraLayers.push(payload);
      state.extraLayersIds.push(payload.id);
    },
    DEL_EXTRA_LAYERS(state, payload) {
      commonFunctions.popById(state.extraLayers, payload);
      commonFunctions.popByData(state.extraLayersIds, payload.id);
    },
    SET_FAVORITE_LAYER_IDS(state, payload) {
      state.favoriteLayerIds = payload;
    },
    SET_HIDE_LAYER(state, payload) {
      if (payload.isHide) {
        state.hideLayers.push(payload.id);
      } else {
        commonFunctions.popByData(state.hideLayers, payload.id);
      }
    },
    SET_ADDRESS_PIN(state, payload) {
      state.addressPin = payload;
    },
    SET_DRAWING_STYLE(state, payload) {
      state.drawingStyle = payload;
    },
    SET_DRAW_TYPE(state, payload) {
      state.drawType = payload;
    },
    SET_APT_TYPE(state, payload) {
      state.aptType = payload;
    },
    SET_OFF_TYPE(state, payload) {
      state.offType = payload;
    },
    SET_SHOW_CADASTRALMAP(state, payload) {
      state.showCadastralMap = payload;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_ROAD_VIEW(state, payload) {
      state.roadView = payload;
    },
    SET_MARKER_ON(state, payload) {
      state.markerOn = payload;
    },
    SET_MARKER_POSITION(state, payload) {
      state.markerPosition = payload;
    },
    SET_UPLOADED_IMAGE(state, payload) {
      state.uploadedImage = payload;
    },
    SET_HIDE_LABEL(state, payload) {
      state.hideLabel[payload.key] = payload.value;
    },
    SET_IS_HIDE_OVERLAY(state, payload) {
      state.isHideOverlay = payload;
    },
    SET_DEV(state, payload) {
      let key = payload[0];
      let val = payload[1];

      let temp = state.dev;

      if (!temp[key]) {
        temp[key] = 0;
      }

      temp[key] = temp[key] + val;
      state.dev = temp;
    },
  },
  actions: {
    addActiveLayers({ commit }, payload) {
      let layer = null;
      if (payload.noActive) {
        layer = payload;
      } else {
        layer = setLayer(payload);
      }

      map
        .getFeatureProperties(layer.id)
        .then((res) => {
          commit("SET_FEATURE_PROPERTIES", {
            id: getId(layer.id),
            data: res.data,
          });

          if (layer.typename) {
            commit("SET_FEATURE_PROPERTIES", {
              id: layer.typename,
              data: res.data,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });

      if (!payload.noActive) {
        commit("SET_ACTIVE_LAYERS", layer);
      }
    },
    addExtraLayers({ commit }, payload) {
      let layer = setExtraLayer(payload);

      map
        .getFeatureProperties(layer.queryId)
        .then((res) => {
          let id = layer.queryId;

          commit("SET_FEATURE_PROPERTIES", {
            id: id,
            data: res.data,
          });
        })
        .catch((err) => {
          console.log(err);
        });
      commit("SET_EXTRA_LAYERS", layer);
    },
    getExtraProperties({ commit }, payload) {
      commit("SET_EXTRA_PROPERTY", {});
      return new Promise((resolve, reject) => {
        this.lastClickedItem = `item/${payload.id}/properties?key=${payload.key}`;
        map
          .getExtraProperties(payload.id, payload.key)
          .then((res) => {
            if (res.config.url != this.lastClickedItem) {
              resolve(false);
            } else {
              commit("SET_EXTRA_PROPERTY", res.data);
              resolve(res);
            }
          })
          .catch((err) => {
            commit("SET_EXTRA_PROPERTY", {});
            reject(err);
          });
      });
    },
    postFeatures({ commit }, payload) {
      return new Promise((resolve, reject) => {
        map
          .postFeatures(payload.layer_id, payload.data)
          .then((res) => {
            resolve(res);
            if (!payload.noResetFeature) {
              commit("SET_FEATURE", null); // Close Pupup
              commit("SET_IS_RESET_TOOLS", null); // Reset seleted tool
              commit("SET_ACTIVE_DRAWING_ID", null); // Reset Actiove Drawing
              commit("SET_IS_REFRESG_LAYER", payload.layer_id); // Reset Layer
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    delFeature({ commit }, payload) {
      return new Promise((resolve, reject) => {
        map
          .delFeature(payload.layer_id, payload.id)
          .then((res) => {
            resolve(res);
            // TODO: 아래 3개 로직 통일
            commit("SET_FEATURE", null);
            commit("SET_IS_RESET_TOOLS", null); // Reset seleted tool
            commit("SET_ACTIVE_DRAWING_ID", null); // Reset Actiove Drawing

            commit("SET_IS_REFRESG_LAYER", payload.layer_id); // Reset Layer
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    putFeature({ commit }, payload) {
      return new Promise((resolve, reject) => {
        map
          .putFeature(payload.layer_id, payload.id, payload.data)
          .then((res) => {
            resolve(res);
            if (!payload.noReload) {
              commit("SET_FEATURE", null);
            }
            commit("SET_IS_REFRESG_LAYER", payload.layer_id); // Reset Layer
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    setItemType({ commit }, payload) {
      if (payload.source_type == "APARTMENT") {
        commit("SET_APT_TYPE", payload.id);
      } else if (payload.source_type == "OFFICETEL") {
        commit("SET_OFF_TYPE", payload.id);
      }
    },
  },
};
